import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "@emcm-ui/utility-class-names";
import Link from "@emcm-ui/component-link";

const Table = ({ data }) => {
  const getClassName = getClassNameFactory(Table.displayName);

  return (
    <div className={getClassName()}>
      <table>
        {data.caption &&
          data.caption.content && <caption>{data.caption.content}</caption>}
        {data.head &&
          data.head.rows &&
          data.head.rows.length && (
            <thead>
              {data.head.rows.map((row, indexRow) => (
                <tr
                  key={(typeof row.key === "undefined"
                    ? indexRow
                    : row.key
                  ).toString()}
                >
                  {row.cells &&
                    row.cells.map((cell, indexCell) => {
                      const style = {};
                      const base = 16;

                      if (cell.width) {
                        style.minWidth = `${cell.width / base}rem`;
                      }

                      return (
                        <th
                          key={(typeof cell.key === "undefined"
                            ? indexCell
                            : cell.key
                          ).toString()}
                        >
                          <div
                            className={getClassName({
                              descendantName: "columnWidthPlaceholder"
                            })}
                            style={style}
                          />
                          {cell.content}
                        </th>
                      );
                    })}
                </tr>
              ))}
            </thead>
          )}
        {data.bodies &&
          data.bodies.length &&
          data.bodies.map((body, indexBody) => (
            <tbody
              key={(typeof body.key === "undefined"
                ? indexBody
                : body.key
              ).toString()}
            >
              {body.rows &&
                body.rows.length &&
                body.rows.map((row, indexRow) => {
                  return (
                    row.hidden !== true && (
                      <tr
                        key={(typeof row.key === "undefined"
                          ? indexRow
                          : row.key
                        ).toString()}
                      >
                        {row.cells &&
                          row.cells.map((cell, indexCell) => (
                            <td
                              key={(typeof cell.key === "undefined"
                                ? indexCell
                                : cell.key
                              ).toString()}
                            >
                              {cell.link && cell.link.href ? (
                                <Link href={cell.link.href}>
                                  {cell.content}
                                </Link>
                              ) : (
                                cell.content
                              )}
                            </td>
                          ))}
                      </tr>
                    )
                  );
                })}
            </tbody>
          ))}
      </table>
    </div>
  );
};

Table.displayName = "TableWithFilters.Table";

Table.propTypes = {
  /**
   * Initialize <input> with a value
   */
  data: PropTypes.object
};

export default Table;
